import styled from 'styled-components';

export const SelectionRowWrapper = styled.div`
  background: var(--light-primary);
  color: var(--text-title-gray);
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 20px;
  border-radius: 10px;
  min-height: 40px;
`;
